<template>
  <div class="storagePayReview">
    <h2>审核仓储付款信息</h2>
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="danger" @click="review('unpass')">不通过</el-button>
          <el-button type="success" @click="review('pass')">通过</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="请填写审核备注：">
        <el-input v-model="data.storagePay.reviewNote" :max="100" />
      </el-form-item>
      <el-form-item label="仓储">
        <el-text>{{ data.storagePay.storage }}</el-text>
      </el-form-item>
      <el-form-item label="申请日期">
        <el-text>{{ data.storagePay.applyDate }}</el-text>
      </el-form-item>
      <el-form-item label="用途">
        <el-text>{{ data.storagePay.useto }}</el-text>
      </el-form-item>
      <el-form-item label="金额">
        <el-text>{{ data.storagePay.amount }}</el-text>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'

const router = useRouter()
const pageParam = cache.getObject(cache.keys.pageParam + "storagePayReview")
const data = reactive({
  storagePay: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  file: {}
})

const review = (reviewState) => {
  const param = { id: data.storagePay.id }
  param.reviewNote = data.storagePay.reviewNote
  param.reviewState = reviewState
  api.post('/backend/storagePay/review', param).then(() => {
    ElMessage.success('保存成功')
    router.go(-1)
  })
}
</script>

<style lang="less">
.storagePayReview {
  margin: auto;
  max-width: 900px;
}
</style>